// eslint-disable-next-line
import util from 'util';
import React from 'react';
// import {StripeProvider} from 'react-stripe-elements';
import { HashRouter as Router } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Theme from "./Theme";
import Home from './Home';

function App(props)  {
    let theme = Theme();
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline/>
      <Router>
        <Home transferIdentity={props.transferIdentity}
              transferAccountId={props.transferAccountId} />
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
